import { useEffect, useState } from "react";
import { Location as TQSLocation } from "../../models/location";
import { Tooltip } from 'react-tooltip';
import { useAppSelector } from "../../reducers/store";

export function LocationCard(props: {
  location: TQSLocation;
  index: number;
  selectedLocation: TQSLocation;
  setSelectedLocation: (location: TQSLocation) => void;
}) {
  const supplierIconUrl = "https://s3.amazonaws.com/com.teamqualityservices.qnet/images/Logo+Q+Only.png";

  const selectedSupplier = useAppSelector((state) => state.supplier.selectedSupplier);
  const selectedProducingFacilities = useAppSelector((state) => state.supplier.selectedProducingFacilities);
  const [qualityCount, setQualityCount] = useState(0);

  useEffect(() => {
    setQualityCount(props.location.qualityAlerts?.filter(q => q.supplier === selectedSupplier?.id || selectedProducingFacilities.map(s => s.id).includes(q.supplier as number))?.filter(q => q.status !== 'Closed').length ?? 0);
  }, [props.location, selectedSupplier, selectedProducingFacilities]);

  const clearPreviousParams = () => {
    const params = new URLSearchParams(window.location.search);
    params.delete("locationId");

    return params;
  };

  const selectLocation = () => {
    if (props.selectedLocation?.id !== props.location?.id) {
      // const newSelectedLocations = [...props.selectedLocations, props.location];
      props.setSelectedLocation(props.location);
      const params = clearPreviousParams();
      params.append("locationId", props.location.id.toString());

      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}${params.toString().length > 0 ? "?" : ""}${params.toString()}`,
      );
    } else {
      // const newSelectedLocations = props.selectedLocations.filter(l => l.id !== props.location.id);
      props.setSelectedLocation({} as TQSLocation);

      const params = clearPreviousParams();
      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}${params.toString().length > 0 ? "?" : ""}${params.toString()}`,
      );
    }
  };

  return (
    <div
      className={`flex cursor-pointer flex-row items-center justify-between gap-x-[6px] rounded-[6px] border-[1px] border-[#E5E5E5] p-[8px] ${props.selectedLocation?.id === props.location?.id ? "bg-[#00000012]" : ""}`}
      key={props.index}
      onClick={() => selectLocation()}
    >
      <div className="mr-[4px] flex h-[40px] w-[40px] items-center justify-center rounded-[50%] border-[1px] bg-[#00000009]">
        <img
          className="h-[25px] w-[25px]"
          src={props.location.oemPicture?.s3Code ?? supplierIconUrl}
          alt="OEM Image"
        />
      </div>

      <div className="ellipse-text flex w-[calc(100%-80px)] flex-col">
        <span className="text-[14px] font-semibold text-[black]">
          {props.location.name}
        </span>
        <span className="text-[14px] font-semibold text-[grey]">
          {props.location.oem?.name ?? "Other"}
        </span>
      </div>

      <div className="flex w-[40px] items-center justify-center">
        {props.selectedLocation?.id === props.location?.id ? (
          <div>
            <span className="text-[10px]">Selected</span>
          </div>
        ) : qualityCount > 0 ? (
          <div className="flex h-[20px] w-[32px] flex-col items-center justify-center rounded-[10px] bg-tqsRed"  data-tooltip-id="my-tooltip" data-tooltip-content="Number of open quality issues">
            <span className="text-[10px] text-[white]">
              {qualityCount}
            </span>
            <Tooltip id="my-tooltip" place="top-end" />
          </div>
        ) : null}
      </div>
    </div>
  );
}
